export const removeNonNumericValues = (num) =>
  num?.toString()?.replace(/[^0-9]/g, "");
